import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useQuantitySectionStyles = makeStyles({
    root: {
        flexDirection: 'column',
        display: 'flex'
    },
    row: {
        marginTop: '10px',
        flexDirection: 'row',
        display: 'flex'
    },
    button: {
        fontSize: tokens.fontSizeHero700,
        backgroundColor: tokens.colorNeutralForegroundInverted,
        height: '50px',
        width: '40px',
        ...shorthands.padding('10px'),
        ...shorthands.borderRadius(tokens.borderRadiusLarge),
        ...shorthands.borderColor('#EEEEEE'),
        ...shorthands.borderWidth(tokens.strokeWidthThin),
        ':hover': {
            cursor: 'pointer',
            fontWeight: 'bold'
        }
    },
    count: {
        fontSize: tokens.fontSizeBase500,
        marginTop: '15px',
        marginLeft: '30px',
        marginRight: '30px'
    },
    cartCount: {
        fontSize: tokens.fontSizeBase500,
        backgroundColor: tokens.colorNeutralForegroundInverted,
        height: '50px',
        width: '60px',
        ...shorthands.borderRadius(tokens.borderRadiusLarge),
        ...shorthands.margin('0', tokens.spacingHorizontalM),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    cartHeader: {
        fontSize: tokens.fontSizeBase500,
        lineHeight: tokens.lineHeightBase500,
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        '&:hover': {
            '-webkit-line-clamp': 'unset', // Show all lines on hover
            height: 'unset' // Show all lines on hover
        }
    }
});
